module.exports = __webpack_public_path__ + "static/media/rectangle.0a0f3d26.png";